import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  IconButton,
  CardMedia,
} from "@mui/material";
import NorthEastIcon from "@mui/icons-material/NorthEast";

const journeyData = [
  {
    title: "Improved Flexibility",
    desc: "Enhance your mobility and release muscle tension through guided yoga routines designed for all levels.",
    img: "/images/card1.jpeg",
  },
  {
    title: "Stress Reduction",
    desc: "Find calm and clarity with breathing and mindfulness practices crafted for everyday balance.",
    img: "/images/card2.webp",
  },
  {
    title: "Emotional Stability",
    desc: "Develop emotional strength and focus through consistent mindfulness and meditation exercises.",
    img: "/images/card3.webp",
  },
];

const StartJourney = () => {
  return (
    <Box sx={{ py: { xs: 6, md: 10 }, px: { xs: 2, md: 8 }, bgcolor: "#fff" }}>
      {/* Section Title */}
      <Typography
        variant="h4"
        sx={{
          fontWeight: "bold",
          textAlign: "center",
          mb: { xs: 4, md: 6 },
          fontSize: { xs: "1.8rem", md: "2.2rem" },
        }}
      >
        Start Your Journey Today
      </Typography>

      {/* Card Grid */}
      <Grid container spacing={6} justifyContent="center">
        {journeyData.map((item, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              sx={{
                borderRadius: "20px",
                position: "relative",
                overflow: "hidden",
                height: 480,
                width:380,
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-end",
                boxShadow: "0px 10px 30px rgba(0,0,0,0.1)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                "&:hover": {
                  transform: "translateY(-6px)",
                  boxShadow: "0px 10px 35px rgba(0,0,0,0.2)",
                },
              }}
            >
              {/* Top Image */}
            <Box
  sx={{
    position: "absolute",
    inset: 0,
    backgroundImage: `
      linear-gradient(to bottom, rgba(0,0,0,0.2), rgba(0,0,0,0.4)),
      url(${item.img})
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
    zIndex: 0,
  }}
/>

              {/* Up Arrow Button */}
              <IconButton
                sx={{
                  position: "absolute",
                  top: 15,
                  right: 15,
                  backgroundColor: "rgba(255,255,255,0.6)",
                  backdropFilter: "blur(6px)",
                  borderRadius: "50%",
                  width: 38,
                  height: 38,
                  "&:hover": {
                    backgroundColor: "rgba(255,255,255,0.8)",
                  },
                }}
              >
                <NorthEastIcon sx={{ color: "#000", fontSize: 20 }} />
              </IconButton>

              {/* Glass Effect Section */}
              <Box
                sx={{
                  position: "relative",
                  zIndex: 1,
                
                  textAlign:"start",
                //   borderTop: "1px solid rgba(255,255,255,0.3)",
                  borderRadius: "0 0 20px 20px",
                  p: 3,
                }}
              >
                <Typography
                  variant="h6"
                  sx={{  mb: 1, color: "#fff" }}
                >
                  {item.title}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "rgba(255,255,255,0.85)",
                    fontSize: "0.9rem",
                    lineHeight: 1.5,
                  }}
                >
                  {item.desc}
                </Typography>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default StartJourney;
